import { Typography, Grid, Chip } from "@material-ui/core";
import millify from "millify";
import { useState, useEffect } from "react";
import NumberFormat from "react-number-format";
import { getBonds } from "../../search-details/network_requests";
import BondsGrid from "./BondsGrid";
import { url } from "../../../constants";
import ListCardMobile from "./ListCardMobile";

export default function BondCardMobile(props) {
  const { Company, tabValue, t, clickable, setCompanyDetail } = props;
  const marketingCap = Company?.MarketCapital?.toString().split(".");
  const marketingCapInt = marketingCap ? marketingCap[0]?.length : 0;
  const [noLogo, setNoLogo] = useState(false);

  const [bonds, setBonds] = useState([]);

  useEffect(async () => {
    const bonds_ = await getBonds(Company?.ISIN);
    setBonds(bonds_);
  }, []);

  return (
    <div
    // style={{ padding: "14px 15px 15px 11px" }}
    >
      <ListCardMobile
        Company={Company}
        tabValue={tabValue}
        setCompanyDetail={setCompanyDetail}
        clickable={clickable}
        t={t}
      />

      {/* <Grid item xs={12} style={{ display: "flex" }}>
        <Grid item xs={6} style={{ display: "flex" }}>
          <Typography
            style={{
              color: "#808080",
              fontSize: "14px",
              fontFamily: "Overpass",
              height: "18px",
              margin: "1px 36px 10px 0",
            }}
          >
            {Company?.ISIN}
          </Typography>
        </Grid>
        <Grid
          item
          xs={6}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Typography
            style={{
              height: "15px",
              margin: "2px 7px 4px 0",
              fontFamily: "Overpass",
              fontSize: "12px",
              color: "#808080",
            }}
          >
            {Company?.Country}
          </Typography>
          <img
            alt="logo"
            style={{ height: "21px", marginLeft: "7px" }}
            src={`${url}/static/CountryFlag/${Company?.Country}.jpg`}
          ></img>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Typography
          style={{
            color: "#16063b",
            fontSize: "18px",
            fontWeight: 900,
            fontFamily: "Overpass",
            margin: "0px 0px 4px 0",
            cursor: props.clickable ? "pointer" : "unset",
          }}
          onClick={() => {
            if (props.clickable) {
              props.setCompanyDetail(Company?.ISIN);
            }
          }}
        >
          {Company?.Name}
        </Typography>
      </Grid>
      <Typography
        style={{
          color: "#0040ff",
          fontSize: "13px",
          fontWeight: 800,
          fontFamily: "Overpass",
          height: "15px",
          margin: " 4px 3px 25px 0",
          lineHeight: 1.15,
        }}
      >
        {Company?.Sector}
      </Typography>
      <Grid item xs={12} style={{ display: "flex" }}>
        <Grid>
          <div
            style={{
              width: "136px",
              height: "159px",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: "0 0 11px 0 #16063b26",
              backgroundColor: "#fff",
              paddingTop: "10px",
              cursor: props.clickable ? "pointer" : "unset",
            }}
            onClick={() => {
              if (props.clickable) {
                props.setCompanyDetail(Company?.ISIN);
              }
            }}
          >
            {!Company?.logos ? (
              <Typography
                style={{
                  fontFamily: "Overpass",
                  fontSize: "14px",
                  textAlign: "center",
                  color: "#808080",
                  maxWidth: "75px",
                }}
              >
                NO LOGO AVAILABLE
              </Typography>
            ) : (
              <img
                src={
                  Company?.logos
                    ? `${url}/static/ISINlogo/${Company?.logos}`
                    : "https://coolbackgrounds.io/images/backgrounds/white/pure-white-background-85a2a7fd.jpg"
                }
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  width: "75px",
                  height: "auto",
                  padding: "0 8px 0 8px",
                }}
                onError={(e) => {
                  setNoLogo(!noLogo);
                }}
              />
            )}
          </div>
        </Grid>
        <Grid style={{ margin: "0px 7px 5px 23px" }}>
          <Typography
            style={{
              color: "#808080",
              fontSize: "12px",
              fontFamily: "Overpass",
            }}
          >
            1-Day
          </Typography>
          <Typography
            style={{
              color: Company?.OneDayPrice >= 0 ? "#259D23" : "#e11c1c",
              fontSize: "12px",
              fontWeight: 800,
              fontFamily: "Overpass",
            }}
          >
            {Company?.OneDayPrice === -99999.99
              ? "N/A"
              : Company?.OneDayPrice
              ? `${Company?.OneDayPrice}`
              : "0.00"}
          </Typography>
          <Typography
            style={{
              color: "#808080",
              fontSize: "12px",
              fontFamily: "Overpass",
              marginTop: "15px",
            }}
          >
            {props.t("price")}
          </Typography>
          <Typography
            style={{
              color: "#808080",
              fontSize: "12px",
              fontWeight: 800,
              fontFamily: "Overpass",
            }}
          >
            {`${Company?.Price} ${Company?.Currency ? Company?.Currency : ""}`}
          </Typography>
          <Typography
            style={{
              color: "#2a0f67",
              marginTop: "15px",
              fontSize: "12px",
              fontFamily: "Overpass",
              fontWeight: 800,
            }}
          >
            {props.t("market_cap")}
          </Typography>
          <Typography
            style={{
              color: "#2a0f67",
              fontSize: "12px",
              fontWeight: 800,
              fontFamily: "Overpass",
            }}
          >
            {Company?.MarketCapital === -99999.99 ? (
              "Not Available"
            ) : marketingCapInt < 7 ? (
              millify(Company?.MarketCapital ? Company?.MarketCapital : 0, {
                units: ["M USD", "B USD"],
                space: true,
                precision: 2,
              })
            ) : (
              <NumberFormat
                value={
                  Company?.MarketCapital
                    ? Company?.MarketCapital / 1000
                    : 0 / 1000
                }
                thousandSeparator={"'"}
                displayType="text"
                suffix={" B USD"}
                decimalScale={2}
              />
            )}
          </Typography>
          <Grid item xs={12} style={{ display: "flex" }}>
            <Chip
              style={{
                height: "20px",
                margin: "12px 12px 10px 0px",
                borderRadius: "10px",
                fontFamily: "Overpass",
                fontWeight: "bold",
                fontSize: "10px",
                boxSizing: "border-box",
                color: tabValue === 1 ? "#0040ff" : "#808080",
                backgroundColor: tabValue === 1 ? "#adc7fe" : "#fff",
                border: tabValue === 1 ? "" : "solid 1px #808080",
              }}
              label={props.t("stock")}
            />
            {Company?.Bonds ? (
              <Chip
                style={{
                  height: "20px",
                  margin: "12px 12px 10px 0px",
                  borderRadius: "10px",
                  fontFamily: "Overpass",
                  fontWeight: "bold",
                  fontSize: "10px",
                  color: tabValue === 0 ? "#0040ff" : "#808080",
                  backgroundColor: tabValue === 0 ? "#adc7fe" : "#fff",
                  border: tabValue === 0 ? "" : "solid 1px #808080",
                  boxSizing: "border-box",
                }}
                label={props.t("bond")}
              />
            ) : null}
          </Grid>
        </Grid>
      </Grid> */}
      <Grid
        style={{
          width: "100%",
          marginTop: "10px",
          // marginTop: "49px",
          overflowX: "scroll",
        }}
      >
        <BondsGrid
          bonds={bonds?.slice(0, 5)}
          setCompanyDetail={props.setCompanyDetail}
          ISIN={Company?.ISIN}
          t={t}
        />
      </Grid>
    </div>
  );
}
